var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "187px",
    height: "348px",
    viewBox: "0 0 187 348",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pen",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M126.266822,213.273205 L126.266822,213.273205 C123.48035,211.735701 122.231931,208.2583 123.490338,205.506608 L173.08753,96.5260077 C176.053774,90.0046287 176.782851,82.3371287 174.495747,75.0680183 C172.008896,67.1392627 166.615726,60.5368044 159.454794,56.5889428 L123.879844,36.9657481 L128.42409,27 L162.920405,46.030615 C172.328492,51.2196908 180.138601,59.5468361 184.053643,69.7017692 C188.148458,80.3331685 187.968686,91.5931826 183.554276,101.273652 L133.587551,211.076056 C132.329145,213.827748 129.053293,214.81171 126.266822,213.273205",
    id: "Fill-73",
    fill: "#2C4A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.19769,21.3215994 L5.74799475,295.077608 C0.69532811,306.923931 1.99344405,317.33761 14.8547773,321.603527 C27.566328,325.81742 35.9841106,320.219905 40.9668786,308.514645 L161.58182,38.8534771 C171.537371,18.0841447 126.163226,0.553267491 116.19769,21.3215994",
    id: "Fill-74",
    fill: "#2C4A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,19.6657 C145.468799,16.7854623 133.92556,18.4108538 129.456563,27.6945129 L18.623436,301.729705 C15.0562546,310.085999 14.6654679,317.71923 19.2547068,323 C17.8619029,322.769661 16.4089779,322.417142 14.8959318,321.915404 C1.98994973,317.645121 0.687327316,307.220784 5.75753457,295.362336 L116.590662,21.3261431 C123.063693,7.85532327 144.456761,10.4912015 156,19.6657",
    id: "Fill-75",
    fill: "#32549C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,310.591241 C40,310.591241 32.9483329,322.982262 15.0510603,339.931862 C11.6820429,343.124987 0.300227379,338.554297 0.168704177,334.173337 C-0.165162412,323.070062 -0.327037122,312.482491 2.94080859,303 C12.703877,317.824214 25.3908074,318.769839 40,310.591241",
    id: "Fill-76",
    fill: "#32549C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,339.754406 L9.86815416,343.515463 L4.12778905,347.650689 C3.05273834,348.424514 1.5010142,347.840322 1.35902637,346.608726 L0.60851927,340.157122 L0,333 C2.71805274,339.894082 8.37728195,341.485573 15,339.754406",
    id: "Fill-77",
    fill: "#34C8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.579563,15.2352702 L161.499178,15.3999691 L161.509226,15.4029455 L154.566032,32.2488636 C152.62676,36.9467505 144.528041,38.4082051 136.479563,35.5130765 C128.441132,32.61894 123.487449,26.4635672 125.416672,21.7646881 L132.369915,4.91877004 L132.379963,4.92174653 L132.440251,4.75208683 C134.369474,0.0532077573 142.468193,-1.40824682 150.516672,1.4868818 C158.565151,4.38201042 163.518834,10.5373833 161.579563,15.2352702",
    id: "Fill-78",
    fill: "#32549C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/Pen.f9d6b1c95ffb3b9c0811cd8295ed2de9.svg";
export { ForwardRef as ReactComponent };